module.exports = __webpack_public_path__ + "img/co_wrapbg6.93ffabc4.png";